import React, { FunctionComponent } from 'react';

import Text from '@gojob/ui-bits/Text';

const Title: FunctionComponent = () => {
  return (
    <>
      <Text as="h2" variant="headline2" gutter={6}>
        Plus concrètement
      </Text>

      <Text as="span" inactive gutter={0.5}>
        Pour un salaire de
      </Text>
      <Text css={{ fontWeight: 500 }} variant="headline2" gutter={4}>
        <strong>1 557 € net</strong>
      </Text>
    </>
  );
};

export default Title;
